<!-- 选手签到 -->
<template>
<div class="detail-wrap">
    <div class="sign-wrap sign" v-if="pageNum === 1">       
        <div class="sign-title overflow-ellipsis-2">{{ title }}</div>
        <el-input v-model="username" placeholder="选手姓名"></el-input>
        <el-input class="mg-t-20" v-model="partnerName" placeholder="搭档姓名" v-if="this.pubType ==='2'"></el-input>
        <el-button class="sign-btn" type="primary" @click="handleSign" round>点击签到</el-button>        
    </div>
    <div class="sign-wrap" v-if="pageNum === 2">
        <div class="back-pre-page">
            <el-button type="primary" @click="backPage(1)">返回上一页</el-button>
            <div class="ramain-txt" v-if="isShowCountDown">剩余时间：{{ countTime }} </div>
            <div class="ramain-txt" v-else>{{ errMsg }}</div>
        </div>        
        <div class="mg-t-20  size20">{{errorShow}}</div>        
        <div class="mg-t-20 mg-b-10 size20">第{{round}}轮对阵</div>
        <table>
             <thead>
                 <tr>                   
                    <th>桌号</th>
                    <th>方位</th>   
                    <th>选手姓名</th>              
                 </tr>
             </thead>
             <tbody>    
                <tr v-for="(item,index) in dataList" :key="index">               
                <td>{{item.deskNo }}</td>
                <td>{{item.seat}}</td>
                <td>{{ item.username }} [{{item.id }}]</td>
                </tr>  
             </tbody>
         </table>
         <el-button class="mg-t-20" type="primary" v-if="isShow" @click="handleScore">记录比赛成绩</el-button>
         <el-button class="mg-t-20 score-round" type="primary" v-if="isShow"
             @click="searchScoreRound">查其它轮的成绩</el-button>
    </div>
    <div class="" v-if="pageNum === 3">
        <div class="sign-wrap">
        <div class="ramain-txt" v-if="isShowCountDown">剩余时间：{{ countTime }}</div>
        <div class="back-pre-page mg-t-10">
            <el-button type="primary" @click="backPage(2)">返回上一页</el-button>
            <el-button type="primary" style="margin-left: 30px;" v-if="gamesId > 3"
                @click="scoreConfirm" :disabled="disabled">{{ confirmBtn }}</el-button>  
        </div>       
        <div class="mg-t-20  size18">第{{round}}轮 {{ deskNo }}桌  
            <el-button class="num-txt" @click="modifyScore">改</el-button>           
        </div>
        <div class="flex-row-1 bold mg-t-10">
            最终成绩为:
            <div class="mg-l-15">
                <span>东西</span><span class="mg-l-15">{{finalScoreWE.score}}</span>
            </div>
            <div class="mg-l-15">
                <span>南北</span><span class="mg-l-15">{{finalScoreNS.score}}</span>
            </div>
        </div>
        <div class="direction">
            东西<span class="color666">({{usernameWE}})</span>
            <span class="card-number-q" @click="gameOverWE" v-if="pubType === '2'">弃</span>   
            <div class="card-number-q" @click="gameOver" v-else>弃</div> 
        </div>   
        <!-- 牌数 -->
        <div class="card-pok">
            <div class="flex-col" v-for="item in tableRowPokWE" :key="item.name">
                <span class="card-number" @click="seatWeatEast(item.name,item.value)"
                :class="getGamesNumClassWE(item)">{{ item.value }}</span>
                <span class="games-num">{{ item.gamesNum ==='第0把' ? '': item.gamesNum }}</span>
            </div>            
        </div>
        <!-- <div class="card-pok"> 
            <span class="card-number" 
                @click="seatWeatEast(item.name,item.value)"
                v-for="item in tableRow" 
                :key="item.name" >{{ item.value }}
            </span>
        </div> -->
        <div class="direction">
            南北<span class="color666">({{ usernameNS }})</span>
            <span class="card-number-q" @click="gameOverSN" v-if="pubType === '2'">弃</span>
        </div>
        <div class="card-pok">
            <div class="flex-col" v-for="item in tableRowPokSN" :key="item.name">
                <span class="card-number" @click="seatSouthNorth(item.name,item.value)"
                :class="getGamesNumClassSN(item)">{{ item.value }}</span>
                <span class="games-num">{{ item.gamesNum ==='第0把'? '': item.gamesNum }}</span>
            </div>            
        </div>
        <!-- <div class="card-pok">           
            <span class="card-number" @click="seatSouthNorth(item.name,item.value)"
            v-for="item in tableRow" :key="item.name">{{ item.value }}</span>
        </div> -->             
    </div>
    <div style="height: 200px;">
    </div>
    </div> 
    <div v-if="pageNum === 4">
        <div class="sign-wrap">   
        <div class="back-pre-page mg-t-10">
                <el-button type="primary" @click="backPage(2)">返回上一页</el-button> 
        </div>        
        <div class="flex-warp mg-t-10 size18">
                <div class="mg-r-15">选择轮数</div>
                <div v-for="item in roundOption"  :key="item" 
                        :class="newRound === item ? 'isChecked':'filter-item'" @click="selectRound(item)">
                        第{{ item  }}轮
                </div>
        </div>
        <div class="flex-row-1 bold mg-t-10">
                最终成绩为:
                <div class="mg-l-15">
                <span>东西</span><span class="mg-l-15">{{finalScoreWE.score}}</span>
                </div>
                <div class="mg-l-15">
                <span>南北</span><span class="mg-l-15">{{finalScoreNS.score}}</span>
                </div>
        </div>
        <div class="direction">
                东西<span class="color666">({{usernameWE}})</span>             
        </div>   
        <!-- 牌数 -->
        <div class="card-pok">
                <div class="flex-col" v-for="item in tableRowPokWE" :key="item.name">
                <span class="card-number"
                :class="getGamesNumClassWE(item)">{{ item.value }}</span>
                <span class="games-num">{{ item.gamesNum ==='第0把' ? '': item.gamesNum}}</span>
                </div>            
        </div>
        <div class="direction">
                南北<span class="color666">({{ usernameNS }})</span>
        </div>
        <div class="card-pok">
                <div class="flex-col" v-for="item in tableRowPokSN" :key="item.name">
                <span class="card-number" 
                :class="getGamesNumClassSN(item)">{{ item.value }}</span>
                <span class="games-num">{{ item.gamesNum ==='第0把'? '': item.gamesNum }}</span>
                </div>            
        </div>
        </div> 
    </div>
    <!-- 广告轮播图 -->
    <div style="position:fixed;bottom: 0;width: 100%;">     
        <el-carousel height="150px" :interval="6000" arrow="never" indicator-position="none">
        <el-carousel-item v-for="(item, index) in bannerList" :key="index" >
            <img :src="item.imageUrl"  style="width: 100%;height: 150px;"/>
        </el-carousel-item>
        </el-carousel>
    </div>   
<el-dialog
  title="确定弃权吗？请选择弃权方位"
  :visible.sync="showSeatScore"
  width="80%"
  :before-close="handleClose">
    <div class="seat-wrap">
        <el-checkbox-group v-model="checkList" @change="changeSingle" class="mg-lr-20">
            <el-checkbox label="东"></el-checkbox>
            <el-checkbox label="南"></el-checkbox>
            <el-checkbox label="西"></el-checkbox>
            <el-checkbox label="北"></el-checkbox>
        </el-checkbox-group>        
    </div>
    <span slot="footer" class="dialog-footer">
        <el-button @click="confirmGameCancel" type="primary">确认弃权</el-button>
        <el-button @click="handleCancel">取消</el-button>
    </span>       
</el-dialog>   
</div>
</template>

<script>
import Qrcode from '@/components/Qrcode'
export default {
    name: 'signIn',
    components: {
        Qrcode,
    },
    data() {
        return {
            isShow: false,
            pageNum: 1,
            username: '',
            partnerName: '',
            signUrl: '',
            publishId: '',
            dataList:[],
            bannerList: [],
            tableRow:[
                {name:2,value:'2',},
                {name:3,value:'3',},
                {name:4,value:'4',},
                {name:5,value:'5',},
                {name:6,value:'6',},
                {name:7,value:'7',},
                {name:8,value:'8',},
                {name:9,value:'9',},
                {name:10,value:'10',},
                {name:11,value:"J",},
                {name:12,value:"Q",},                
                {name:13,value:"K",},
                {name:14,value:"A",},
                {name:15,value:"A+",},
            ],  
            tableRowPokWE:[
                {name:2,value:'2',gamesNum:''},
                {name:3,value:'3',gamesNum:''},
                {name:4,value:'4',gamesNum:''},
                {name:5,value:'5',gamesNum:''},
                {name:6,value:'6',gamesNum:''},
                {name:7,value:'7',gamesNum:''},
                {name:8,value:'8',gamesNum:''},
                {name:9,value:'9',gamesNum:''},
                {name:10,value:'10',gamesNum:''},
                {name:11,value:"J",gamesNum:''},
                {name:12,value:"Q",gamesNum:''},
                {name:13,value:"K",gamesNum:''},
                {name:14,value:"A",gamesNum:''},
                {name:15,value:"A+",gamesNum:''},
            ],   
            tableRowPokSN:[
                {name:2,value:'2',gamesNum:''},
                {name:3,value:'3',gamesNum:''},
                {name:4,value:'4',gamesNum:''},
                {name:5,value:'5',gamesNum:''},
                {name:6,value:'6',gamesNum:''},
                {name:7,value:'7',gamesNum:''},
                {name:8,value:'8',gamesNum:''},
                {name:9,value:'9',gamesNum:''},
                {name:10,value:'10',gamesNum:''},
                {name:11,value:"J",gamesNum:''},
                {name:12,value:"Q",gamesNum:''},
                {name:13,value:"K",gamesNum:''},
                {name:14,value:"A",gamesNum:''},
                {name:15,value:"A+",gamesNum:''},
            ],          
            tableRowScore:[
                {name:1,WE:'',NS:''},
                {name:2,WE:'',NS:''},
                {name:3,WE:'',NS:''},
                {name:4,WE:'',NS:''},
                {name:5,WE:'',NS:''},
                {name:6,WE:'',NS:''},
                {name:7,WE:'',NS:''},
                {name:8,WE:'',NS:''},
                {name:9,WE:'',NS:''},
                {name:10,WE:'',NS:''},
                {name:11,WE:'',NS:''},
                {name:12,WE:'',NS:''},
                {name:13,WE:'',NS:''},
                {name:14,WE:'',NS:''},
                {name:15,WE:'',NS:''},
            ],
            errorShow: '',
            title: '',
            round: 1,
            deskNo: 1,
            pubType: '1',
            gradeUpdate: false,
            originPok: [],
            cardWestEast: [],
            cardSouthNorth: [],
            scoreList: [],
            scoreAllList: [],
            thingPoker: 2,
            northSouthPoker: 2,
            gamesId: 1,
            disabled: false,
            scoreWestEast:0,
            scoreSouthNorth: 0, 
            confirmBtn: '确认提交',
            usernameWE: '',
            usernameNS: '',
            isShowCountDown: false,
            errMsg: '',
            countTime: '',
            countdownTimer: null,
            minute: 0,
            second: 0,
            showSeatScore: false,
            checkList: [],
            eastScore: 2,
            southScore: 2,
            westScore: 2,
            northScore: 2,  
            playStatus: false,
            maxScoreWE: '',
            maxScoreSN: '',
            finalScore: [],
            finalScoreWE: '',
            finalScoreNS: '',
            isActive: 1,
            deskNoNew: '',
            newRound: 1
        }
    },
    created() {
        this.publishId = this.$route.query.id
        this.pubType = this.$route.query.type
        setTimeout(() => {
            this.initData()
        }, 300);
    },
    mounted() {
        this.getPok()
        this.getBannerList()
    },
    methods: {
        // 赛事查询
        initData(){
            let params = {
                opcode: this.$code.PublishQuery,
                i_serial_mark: this.publishId,
                c_status: '',
                v_type: '',
                v_theme: '',
                start_date: '',
                end_date: '',
                pagesize: 10,
                page: 1,
            }
            this.$api._requestAPI(params).then(res =>{
                if (res.IsSuccess) {
                    let result = res.Data.DataTable
                    let list = result.map(item=>{                        
                        return{
                            title: item['主题'],
                            amount: item['参赛人数'],
                            address: item['赛事地点'],
                            sponsor: item['赞助'],
                            maxNum: item['每局最大升级数'],
                            round:  item['比赛轮数'] + 1,
                            maxRound: item['轮数']
                        }
                    })
                    this.title = list[0].title
                    this.round = list[0].round <= list[0].maxRound ? list[0].round : list[0].maxRound
                    this.maxNumber = list[0].maxNum
                    // console.log('round',this.round,'最大升级数',this.maxNumber)
                    let maxRound = Array(list[0].maxRound).fill(0).map((_, i) => i + 1)
                    this.roundOption = maxRound
                }
            })
        },
        getBannerList(){
            let params = {
                opcode: 1069,
                i_serial_mark: this.publishId,
            }
            this.$api._requestAPI(params).then(res=>{
                if(res.IsSuccess){
                    let result = res.Data.DataTable
                    if(result.length > 0){
                        let arr = result.map(item=>{
                            return{
                                id: item['序号'],
                                imageUrl: item['广告图片'],
                                status: item['状态'],
                            }           
                        })
                        this.bannerList = arr
                    }
                }
            })
        },
        // 选手签到
        handleSign(){
            if(this.username === ''){
                this.$message.error("请输入选手姓名！")
                return false
            }
            if(this.pubType === '2'){
                if(this.partnerName === ''){
                    this.$message.error("请输入搭档姓名！")
                    return false
                }
            }
            let params = {
                opcode: this.$code.SignIn,
                i_serial_mark:  this.publishId,
                v_player_no: '',
                v_player_name: this.username,
                v_player_phone: '',
                v_partner_no: '',
                v_partner_name: this.partnerName,
                v_partner_phone: '',
                c_status: 1,
            }            
            this.$api._requestAPI(params).then(res=>{
                if(res.IsSuccess){     
                    this.$message.success(res.Message)               
                    this.playersId = this.$help.regexStr(res.Message)               
                    this.pageNum = 2
                    setTimeout(()=>{
                        this.initData()
                        this.getSignQuery()
                        this.getTimeQuery()
                    },100)                    
                }else{
                    this.$message.error(res.Message)
                }
            })
        },
        // 签到查询
        getSignQuery(){
            let params = {
                opcode: this.$code.SignQuery,
                i_serial_mark: this.publishId,
                i_players_number: this.playersId,
                i_round: this.round,
            }
            this.$api._requestAPI(params).then(res=>{
                if(res.IsSuccess){
                    this.isShow = true
                    let result = res.Data.DataTable
                    this.dataList = result.map(item=>{
                        return{
                            deskNo: item['桌号'],
                            id: item['选手编号'],
                            username: item['选手名称'],
                            company: item['协会（俱乐部）'],
                            seat: item['座位'],
                        }
                    })
                    this.deskNo = this.dataList[0].deskNo   
                    this.errorShow = ''   
                    if(this.pubType === '2'){
                        let usernameWE = this.dataList.filter(i=>i.seat.includes('东-西'))
                        let usernameNS = this.dataList.filter(i=>i.seat.includes('南-北'))
                        this.usernameWE = usernameWE[0].username
                        this.usernameNS = usernameNS[0].username
                    }else{
                        let usernameW = this.dataList.filter(i=>i.seat.includes('东'))
                        let usernameE = this.dataList.filter(i=>i.seat.includes('西'))
                        let usernameN = this.dataList.filter(i=>i.seat.includes('南'))
                        let usernameS = this.dataList.filter(i=>i.seat.includes('北'))
                        this.usernameWE = usernameW[0].username +'-'+usernameE[0].username
                        this.usernameNS = usernameN[0].username +'-'+usernameS[0].username
                    }  
                    setTimeout(()=>{
                        this.getAllScore()
                        this.getNewScore()
                    },200)             
                }else{
                    this.isShow = false
                    this.errorShow = res.Message
                    this.$message.error(res.Message)
                }
            })
        },
        backPage(n){
            this.pageNum = n
            this.newRound = 1
            this.initData()
        },
        handleScore(){    
            clearInterval(this.countdownTimer)
            this.getTimeQuery()   
            setTimeout(()=>{
                if(this.playerStatus){
                    this.pageNum = 3
                    this.getAllScore()
                    this.getNewScore()
                }else{
                    this.$message.error('请提醒裁判点倒计时，倒计时开始，方可记录成绩。')               
                }   
            },500) 
        },
        // 查其它轮的成绩
        searchScoreRound(){
            this.pageNum = 4
            this.getScoreQuery()
        },
        getPok(){
            let params = {
                opcode: this.$code.SystemCode,
                v_parent_name: '',
                i_no: 25
            }
            this.$api._requestAPI(params).then(res=>{
                if(res.IsSuccess){
                    let result = res.Data.DataTable
                    this.originPok = result.map(item=>{
                        return {
                            name: item['词条索引'],
                            value: item['中文描述']
                        }
                    })  
                    // this.cardWestEast =  this.originPok.filter(item=> item.index<this.maxNumber+3)
                    // this.cardSouthNorth = this.originPok.filter(item=> item.index<this.maxNumber+3)
                    
                    // console.log("原始牌",this.originPok)
                    // console.log("东西",this.cardWestEast)
                    // console.log("南北",this.cardSouthNorth)
                }
            })
        },
        //选手赛事成绩查询
        getGradeQuery(v){
            let params = {
                opcode: this.$code.GradeQuery,
                i_serial_mark: this.publishId,
                i_games_id: v-1,
                i_desk_no: this.deskNo,
                i_round: this.round,
            }
            // console.log(params)
            this.$api._requestAPI(params).then(res=>{
                if(res.IsSuccess){
                    let result = res.Data.DataTable
                    if(result.length > 0){
                        this.scoreList = result.map(item=>{
                            return{
                                deskNo: item['桌号'],
                                id: item['选手编号'],
                                username: item['选手名称'],
                                company: item['协会（俱乐部）'],
                                gamesNum: item['局数'],
                                seat: item['座位'],
                                round: item['轮数'],
                                score: item['成绩']
                            }
                        })
                        let westEast = this.scoreList.filter(i=>i.seat.includes('东'))
                        this.thingPoker = westEast[0].score
                        
                        let southNorth = this.scoreList.filter(i=>i.seat.includes('南'))
                        this.northSouthPoker = southNorth[0].score
                    }else{
                        this.scoreList = []
                    }
                    // console.log('东西',this.thingPoker)
                    // console.log('南北',this.northSouthPoker)
                }else{
                    
                }
            })
        },
        // 查询每轮全部局数的成绩
        getAllScore(){
            let params = {
                opcode: this.$code.GradeQuery,
                i_serial_mark: this.publishId,
                i_games_id: 0,
                i_desk_no: this.deskNo,
                i_round: this.round,
            }
            this.$api._requestAPI(params).then(res=>{
                if(res.IsSuccess){
                    let result = res.Data.DataTable
                    let arr = result.map(item=>{
                        return{
                            id: item['选手编号'],
                            username: item['选手名称'],
                            company: item['协会（俱乐部）'],
                            gamesNum: item['局数'],
                            seat: item['座位'],
                            round: item['轮数'],
                            score: item['成绩']
                        }
                    })                  
                    let list  = this.selectDeskNo(arr)
                    
                    let lastArr = list[list.length-1]
                    this.gamesId = lastArr.gamesNum + 1
                    // console.log('last',lastArr.users) 
                    for(let i of lastArr.users){   
                        let score = i.score
                        if(score === 'J'){
                            score= 11
                        }else if(score === 'Q'){
                            score= 12
                        }else if(score === 'K'){
                            score= 13
                        }else if(score === 'A'){
                            score= 14
                        }else if(score === 'A+'){
                            score= 15
                        }                         
                        if(i.seat.includes('东')){
                            this.scoreWestEast = Number(score) + this.maxNumber
                            // console.log('东西最大升级数', this.scoreWestEast)
                            this.thingPoker = i.score
                        }
                        if(i.seat.includes('南')){
                            this.scoreSouthNorth = Number(score)+ this.maxNumber
                            // console.log('南北最大升级数',this.scoreWestEast)
                            this.northSouthPoker = i.score
                        }
                    }
                    if(lastArr.gamesNum !== 111){
                        this.disabled= false
                        this.confirmBtn = '确认提交'
                    } 

                    if(this.pubType === '2'){
                        console.log('2=')
                        this.finalScoreWE = lastArr.users[0],
                        this.finalScoreNS = lastArr.users[1]
                    }else{
                        console.log('1=')
                        this.finalScoreWE = lastArr.users[0],
                        this.finalScoreNS = lastArr.users[2]
                    } 

                    // 取到最后一条数据， 判断最大升级数不能超过几
                    let lastGames =  list.filter(i=> i.gamesNum === 111)   

                    this.scoreAllList = list.filter(i=> i.gamesNum !== 111)
                    if(lastGames.length === 1 && this.scoreAllList.length ===0 ){          
                        this.scoreAllList = list.filter(i=> i.gamesNum === 111)          
                    }
                    // console.log('全部分数',this.scoreAllList)
                     // 取到东西、南北成绩
                    let score = this.scoreAllList.map((item,index)=>{
                        return{
                            WE: item.users[0].score,
                            NS: item.users[item.users.length-1].score
                        }
                    })
                    // console.log('fenshu',score)
                    // 合并2个数组，把分数插入到tableRow
                    let combinedScores = this.tableRow.map((row, index) => {  
                        let scoreObj = index < score.length ? score[index] : { WE: '', NS: '' };  
                        return {  
                            name: row.name,  
                            WE: scoreObj.WE,  
                            NS: scoreObj.NS
                        };  
                    });  
                    // console.log('得分',score,combinedScores)
                    this.tableRowScore = combinedScores
                }
            })
        },
        selectDeskNo(arr){
            let result = []
            arr.forEach(item => {
                if(!result.some(i => i.gamesNum === item.gamesNum )){
                    result.push({
                        gamesNum: item.gamesNum,
                        users: arr.filter(user => user.gamesNum === item.gamesNum)
                    })
                }
            });
            return result
         },
        // 每一局的分数
        scoreSubmit(){
            let params = {
                opcode: this.$code.ScoreSub,                
                i_serial_mark: this.publishId,
                i_players_number: this.playersId,
                i_round: this.round,
                i_games_id: this.gamesId,
                i_desk_no: this.deskNo,
                thing_poker: this.thingPoker,
                northsouth_poker: this.northSouthPoker,
            }
            this.$api._requestAPI(params).then(res=>{
                if(res.IsSuccess){
                    this.getAllScore()
                    this.getNewScore()
                }else{
                    this.$message.error(res.Message)
                }                
            })
        },
        seatWeatEast(name,value){
            let number = Number(name)
            let score = this.getPokNumber(this.thingPoker)
            // console.log('东西',this.thingPoker,score,number)
            
            if(number <= Number(score)){
                this.$message({
                    type: 'error',
                    message: '不允许倒扣级数',
                    duration: 3000
                })
                return false
            }
            if(number === 15 && score < 14){
                this.$message({
                    type: 'error',
                    message: '请先打A',
                    duration: 3000
                })
                return false
            }
            if(number > this.scoreWestEast){
                this.$message.error('最大升级数不能超过'+ this.maxNumber)
                return false
            }else{
                this.thingPoker = value
                if(number === 15){
                    this.scoreLast()
                }else{
                    this.scoreSubmit()  
                }
            }  
        },
        seatSouthNorth(name,value){
            let number = Number(name)
            let score = this.getPokNumber(this.northSouthPoker)
            // console.log('南北',this.northSouthPoker,score)
            
            if(number <= Number(score)){
                this.$message({
                    type: 'error',
                    message: '不允许倒扣级数',
                    duration: 3000
                })
                return false
            }
            if(number === 15 && score < 14){
                this.$message({
                    type: 'error',
                    message: '请先打A',
                    duration: 3000
                })
                return false
            }
            if(number > this.scoreSouthNorth){
                this.$message.error('最大升级数不能超过'+ this.maxNumber)
                return false
            }else{
                this.northSouthPoker = value
                if(number === 15){
                    this.scoreLast()
                }else{
                    this.scoreSubmit()  
                }
            }  
        },
        scoreLast(){
            let params = {
                opcode: this.$code.ScoreSub,                
                i_serial_mark: this.publishId,
                i_players_number: this.playersId,
                i_round: this.round,
                i_games_id: this.gamesId,
                i_desk_no: this.deskNo,
                thing_poker: this.thingPoker,
                northsouth_poker: this.northSouthPoker,
            }
            this.$api._requestAPI(params).then(res=>{                
                if(res.IsSuccess){
                    this.confirmA()    
                }else{
                    this.$message.error(res.Message)
                }       
            })
        },
        // A+确认
        confirmA(){
            let params = {
                opcode: this.$code.ScoreConfirm,                
                i_serial_mark: this.publishId,
                i_players_number: this.playersId,
                i_round: this.round,
                i_desk_no: this.deskNo,
                thing_poker: this.thingPoker,
                northsouth_poker: this.northSouthPoker,
            }
            this.$api._requestAPI(params).then(res=>{
                if(res.IsSuccess){
                    this.disabled = true
                    this.confirmBtn = '本轮成绩已提交！'
                    this.$message.success('本轮成绩提交成功！')
                    setTimeout(()=>{
                        this.getAllScore()
                        this.getNewScore()
                    },100)
                }else{
                    this.$message.error(res.Message)
                }
            })
        },
        // 本局赛事确认
        scoreConfirm(){
            let params = {
                opcode: this.$code.ScoreConfirm,                
                i_serial_mark: this.publishId,
                i_players_number: this.playersId,
                i_round: this.round,
                i_desk_no: this.deskNo,
                thing_poker: this.thingPoker,
                northsouth_poker: this.northSouthPoker,
            }
            // console.log(params)
            this.$api._requestAPI(params).then(res=>{
                if(res.IsSuccess){
                    this.disabled = true
                    this.confirmBtn = '本轮成绩已提交！'
                    this.$message.success(res.Message)
                }else{
                    this.$message.error(res.Message)
                }
            })
        },
        modifyScore(){      
            this.$confirm('确定删除这一局的分数吗？', 
                {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    cancelButtonClass: 'custom-cancel-button',
                    type:'warning',
                    customClass: 'my-messageBox'
                }
            ).then(res=>{
                if(this.gamesId <= 1){
                    this.gradeUpdate = false
                    this.thingPoker  = 2
                    this.northSouthPoker = 2
                    this.$message.error('成绩已清除，请重新选择成绩')
                }else{
                    this.gradeUpdate = true
                    this.thingPoker = '删除'
                    this.northSouthPoker = '删除'
                    this.gamesId = this.gamesId -1 
                    this.scoreSubmit()
                    this.getGradeQuery(this.gamesId -1)
                }
            }).catch(err=>{

            })  
        },
        // 弃权调用的接口
        gameOverSub(){
            let params = {
            opcode: this.$code.ScoreConfirm,                
            i_serial_mark: this.publishId,
            i_players_number: this.playersId,
            i_round: this.round,
            i_games_id: this.gamesId,
            i_desk_no: this.deskNo,
            thing_poker: this.thingPoker,
            northsouth_poker: this.northSouthPoker,
        }
        this.$api._requestAPI(params).then(res=>{
            if(res.IsSuccess){
                this.$message.success(res.Message)
                this.getAllScore()
                this.getNewScore()
            }else{
                this.$message.error(res.Message)
            }                
        })
        },
        // 东西 弃
        gameOverWE(){
            this.$confirm('这一轮分数，确定弃权吗？',
            {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                cancelButtonClass: 'custom-cancel-button',
                type:'warning',
                customClass: 'my-messageBox'
            }
            ).then(res=>{
                this.thingPoker = '弃',
                this.northSouthPoker = 6
                setTimeout(()=>{
                    this.gameOverSub()
                },500)
            }).catch(err=>{}) 
        },
        // 南北 弃
        gameOverSN(){
            this.$confirm('这一轮分数，确定弃权吗？',
            {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                cancelButtonClass: 'custom-cancel-button',
                type:'warning',
                customClass: 'my-messageBox'
            }
            ).then(res=>{
                this.thingPoker =  6
                this.northSouthPoker = '弃'
                setTimeout(()=>{
                    this.gameOverSub()
                },500)
            }).catch(err=>{}) 
        },
        // 超过10的牌 替换值
        getPokNumber(score){
            if(score === 'J'){
                score= 11
            }else if(score === 'Q'){
                score= 12
            }else if(score === 'K'){
                score= 13
            }else if(score === 'A'){
                score= 14
            }else if(score === 'A+'){
                score= 15
            }else{
                score = score
            } 
            return score
        },
        // 倒计时查询
        getTimeQuery(){
            let params = {
                opcode: this.$code.TimerQuery,
                i_serial_mark: this.publishId,
            }
        this.$api._requestAPI(params).then(res=>{
            if(res.IsSuccess){
            let list = res.Data.DataTable
            let result = list.map(i=>{
                return{
                    t: i['倒计时'],
                    status: i['状态'],
                }
            })
            let arr = result[0]
            if(arr.status === '开始'){
              let arr2 = arr.t.split(':')
                if(Number(arr2[0]) > 0){
                    this.minute = Number(arr2[0])
                    this.second =  Number(arr2[1])
                }else{
                  this.minute = 0
                  this.second =  Number(arr2[1])
                }  
                this.countDownFn()  
            }else if(arr.status === '暂停'){
              // 暂停状态 
              this.countTime = result[0].t
              clearInterval(this.countdownTimer)
            }else if(arr.status === '结束'){
              // 结束状态 
              this.countTime = '00:00'
              clearInterval(this.countdownTimer)
            }     
            this.isShowCountDown = true
            this.playerStatus = true 
            }else{
                this.isShowCountDown = false
                this.errMsg = '倒计时未开始！'
                this.playerStatus = false
            }
        })
    },
    // 单人赛东西南北弃
    gameOver(){
        this.showSeatScore = true
    },
    changeSingle(value){
        if(value.length > 0){
            this.eastScore =  value.includes('东')?'弃':'6'
            this.southScore =  value.includes('南')?'弃':'6'
            this.westScore =  value.includes('西')?'弃':'6'
            this.northScore =  value.includes('北')?'弃':'6'
        }
    },
    confirmGameCancel(){
        let params = {
            opcode: this.$code.SingelGameOver2,
            i_serial_mark: this.publishId,
            i_round: this.round,
            i_desk_no: this.deskNo,
            i_players_number: this.playersId,
            east_poker: this.eastScore,
            south_poker: this.southScore,
            west_poker: this.westScore,
            north_poker: this.northScore,
        }
        this.$api._requestAPI(params).then(res =>{
            if(res.IsSuccess){
                this.showSeatScore = false;
                this.checkList = []
                this.getAllScore()
                this.getNewScore()
            }else{
                this.$message.error(res.Message)
            }
        })
    },
    handleClose(){
        this.thingPoker = ''
        this.northSouthPoker = ''
        this.checkList = []
    },
    handleCancel(){
        this.showSeatScore = false;
        this.checkList = []
    },
    // 倒计时方法
    countDownFn(){
        // console.log(this.data.minute,this.data.second)
        let remainingTime = this.minute * 60 + this.second
        this.countdownTimer = setInterval(()=>{
        var minutes = Math.floor(remainingTime / 60);
        var seconds = remainingTime % 60;
        // 在页面上更新倒计时显示
        let displayTime = minutes + ':' + (seconds < 10 ? '0' + seconds : seconds)
        this.countTime = displayTime
        if(remainingTime > 0){
            this.playStatus = true
            remainingTime--;
        }else{
            // 当倒计时结束时清除定时器
            clearInterval(this.countdownTimer)
        }
        },1000)
    },
    getNewScore(){
        let params = {
            opcode: this.$code.ScoreQueryNew,
            i_serial_mark: this.publishId,
            i_round: this.round,
            i_desk_no: this.deskNo
        }
        this.$api._requestAPI(params).then(res=>{
            if(res.IsSuccess){
                let arr = res.Data.DataTable
                let newArr = arr.map(item=>{
                    let score = JSON.parse(item['成绩'])
                    return{
                        ...score,                        
                    }
                })
                let WE = newArr[0]
                let SN = newArr[1]
                let scoreWE = [];
                let scoreSN = []
                for (var key in WE) {
                    if (WE.hasOwnProperty(key)) {
                        var value = WE[key];
                        var newObj = {
                            key: key,
                            value: value
                        };                        
                        scoreWE.push(newObj);
                    }
                }
                for (var key in SN) {
                    if (SN.hasOwnProperty(key)) {
                        var value = SN[key];
                        var newObj = {
                            key: key,
                            value: value
                        }; 
                        scoreSN.push(newObj);
                    }
                }
                // console.log('东西数组',scoreWE)
                // console.log('南北分数',scoreSN)
                if(scoreWE.length > 0){
                    this.maxScoreWE = scoreWE[scoreWE.length-1].value
                }
                if(scoreSN.length > 0){
                    this.maxScoreSN = scoreSN[scoreSN.length-1].value
                }
                let scoreObjWE = JSON.parse(JSON.stringify(this.tableRow))
                // 遍历数组2，并基于array1中的匹配来更新gamesNum
                scoreObjWE.forEach(function(obj2,index) {
                    // 在array1中查找与obj2.value匹配的对象
                    var matchingObj1 = scoreWE.find(function(obj1) {
                        return obj1.value === obj2.value;
                    });                    
                    // 如果找到匹配的对象，则更新gamesNum
                    if (matchingObj1) {
                        obj2.gamesNum = matchingObj1.key;                    
                    }else{
                        obj2.gamesNum = ''
                    }                   
                });
                let scoreObjSN = JSON.parse(JSON.stringify(this.tableRow))
                scoreObjSN.forEach(function(obj2,index) {
                    // 在array1中查找与obj2.value匹配的对象
                    var matchingObj1 = scoreSN.find(function(obj1) {
                        return obj1.value === obj2.value;
                    });                    
                    // 如果找到匹配的对象，则更新gamesNum
                    if (matchingObj1) {
                        obj2.gamesNum = matchingObj1.key;   
                    }else{
                        obj2.gamesNum = ''
                    }
                });  
                this.tableRowPokWE = scoreObjWE
                this.tableRowPokSN = scoreObjSN
                // console.log(scoreObjWE,this.tableRowPokWE)              
            }            
        })
    },
    getGamesNumClassWE(row){
        if(row.gamesNum !=='' && row.value === this.maxScoreWE){            
            return 'isLastGames'
        }else 
        if(row.gamesNum !==''){
            return 'isSelected'
        }else{
            return ''
        }
    },
    getGamesNumClassSN(row){
        if(row.gamesNum !=='' && row.value === this.maxScoreSN){            
            return 'isLastGames'
        }else 
        if(row.gamesNum !==''){
            return 'isSelected'
        }else{
            return ''
        }
    },
    // 查询每一轮的成绩桌号
    getScoreQuery(){
            let params = {
                opcode: this.$code.SignQuery,
                i_serial_mark: this.publishId,
                i_players_number: this.playersId,
                i_round: this.newRound,
            }
            this.$api._requestAPI(params).then(res=>{
                if(res.IsSuccess){
                    this.isShow = true
                    let result = res.Data.DataTable
                    let  arr  = result.map(item=>{
                        return{
                            deskNo: item['桌号'],
                            id: item['选手编号'],
                            username: item['选手名称'],
                            company: item['协会（俱乐部）'],
                            seat: item['座位'],
                        }
                    })
                    this.deskNoNew = arr[0].deskNo   

                    if(this.pubType === '2'){
                        let usernameWE = arr.filter(i=>i.seat.includes('东-西'))
                        let usernameNS = arr.filter(i=>i.seat.includes('南-北'))
                        this.usernameWE = usernameWE[0].username
                        this.usernameNS = usernameNS[0].username
                    }else{
                        let usernameW = arr.filter(i=>i.seat.includes('东'))
                        let usernameE = arr.filter(i=>i.seat.includes('西'))
                        let usernameN = arr.filter(i=>i.seat.includes('南'))
                        let usernameS = arr.filter(i=>i.seat.includes('北'))
                        this.usernameWE = usernameW[0].username +'-'+usernameE[0].username
                        this.usernameNS = usernameN[0].username +'-'+usernameS[0].username
                    }  
                    setTimeout(()=>{
                        this.getAllScoreRound()
                        this.getScoreRound()
                    },200)             
                }else{
                    setTimeout(()=>{
                        this.getAllScoreRound()
                        this.getScoreRound()
                    },200)     
                    this.$message.error(res.Message)
                }
            })
        },
        selectRound(index){
            this.newRound = index
            this.isActive = index
            setTimeout(()=>{
                this.getScoreQuery()
            },200)
        },
        getScoreRound(){
            let params = {
                opcode: this.$code.ScoreQueryNew,
                i_serial_mark: this.publishId,
                i_round: this.newRound,
                i_desk_no: this.deskNoNew
            }
            this.$api._requestAPI(params).then(res=>{
            if(res.IsSuccess){
                let arr = res.Data.DataTable
                let newArr = arr.map(item=>{
                    let score = JSON.parse(item['成绩'])
                    return{
                        ...score,                        
                    }
                })
                let WE = newArr[0]
                let SN = newArr[1]
                let scoreWE = [];
                let scoreSN = []
                for (var key in WE) {
                    if (WE.hasOwnProperty(key)) {
                        var value = WE[key];
                        var newObj = {
                            key: key,
                            value: value
                        };                        
                        scoreWE.push(newObj);
                    }
                }
                for (var key in SN) {
                    if (SN.hasOwnProperty(key)) {
                        var value = SN[key];
                        var newObj = {
                            key: key,
                            value: value
                        }; 
                        scoreSN.push(newObj);
                    }
                }
                // console.log('东西数组',scoreWE)
                // console.log('南北分数',scoreSN)
                if(scoreWE.length > 0){
                    this.maxScoreWE = scoreWE[scoreWE.length-1].value
                }
                if(scoreSN.length > 0){
                    this.maxScoreSN = scoreSN[scoreSN.length-1].value
                }
                let scoreObjWE = JSON.parse(JSON.stringify(this.tableRow))
                // 遍历数组2，并基于array1中的匹配来更新gamesNum
                scoreObjWE.forEach(function(obj2,index) {
                    // 在array1中查找与obj2.value匹配的对象
                    var matchingObj1 = scoreWE.find(function(obj1) {
                        return obj1.value === obj2.value;
                    });                    
                    // 如果找到匹配的对象，则更新gamesNum
                    if (matchingObj1) {
                        obj2.gamesNum = matchingObj1.key;                    
                    }else{
                        obj2.gamesNum = ''
                    }                   
                });
                let scoreObjSN = JSON.parse(JSON.stringify(this.tableRow))
                scoreObjSN.forEach(function(obj2,index) {
                    // 在array1中查找与obj2.value匹配的对象
                    var matchingObj1 = scoreSN.find(function(obj1) {
                        return obj1.value === obj2.value;
                    });                    
                    // 如果找到匹配的对象，则更新gamesNum
                    if (matchingObj1) {
                        obj2.gamesNum = matchingObj1.key;   
                    }else{
                        obj2.gamesNum = ''
                    }
                });  
                this.tableRowPokWE = scoreObjWE
                this.tableRowPokSN = scoreObjSN
                // console.log(scoreObjWE,this.tableRowPokWE)              
            }else{
                console.log('暂无成绩')
            }            
        })
        },
        // 查询每轮全部局数的成绩
        getAllScoreRound(){
            let params = {
                opcode: this.$code.GradeQuery,
                i_serial_mark: this.publishId,
                i_games_id: 0,
                i_desk_no: this.deskNoNew,
                i_round: this.newRound,
            }
            this.$api._requestAPI(params).then(res=>{
                if(res.IsSuccess){
                    let result = res.Data.DataTable
                    let arr = result.map(item=>{
                        return{
                            id: item['选手编号'],
                            username: item['选手名称'],
                            company: item['协会（俱乐部）'],
                            gamesNum: item['局数'],
                            seat: item['座位'],
                            round: item['轮数'],
                            score: item['成绩']
                        }
                    })     
                    if(arr.length > 0){             
                        let list  = this.selectDeskNo(arr)
                        
                        let lastArr = list[list.length-1]  
                    
                        if(this.pubType === '2'){
                            console.log('2=')
                            this.finalScoreWE = lastArr.users[0],
                            this.finalScoreNS = lastArr.users[1]
                        }else{
                            console.log('1=')
                            this.finalScoreWE = lastArr.users[0],
                            this.finalScoreNS = lastArr.users[2]
                        } 
                    }else{
                        this.finalScoreWE = ''
                        this.finalScoreNS = ''
                        this.$message.error('该轮暂无成绩')
                    }
                
                }
            })
        },
    },
    destroyed(){
        clearInterval(this.countdownTimer)
    }
}
</script>
<style lang='scss' scoped>
@media screen and (max-width:768px){
    table {
     width: 100%;
     border-collapse: collapse;
   }
   th, td {
     border: 1px solid #999;
     padding: 8px;
     text-align: left;
     font-size: 16px;
   }
   tr:nth-child(even) {
    //  background-color: #bbffbb;
   }
   thead th {
     background-color: #f2f2f2;
     font-size: 18px;
     text-align: center;
   }
   .table-label {
     display: flex;
     justify-content: space-between;
     align-items: center;
     padding: 10px;
     background-color: #f9f9f9;
     border: 1px solid #ddd;
   } 
   .sign-page{
    width: 100%;
    background-color: #f5f5f5;
   }
  .detail-wrap{    
    height: 100vh;
    margin: 0 auto;
    border: 0;    
  }
  .head-color{
    height: 30px;
    background-color: #fca850;
  }
  .sign-wrap-cell{
    padding-top: 20px;
  }
  .sign-wrap{
    width: 90vw ;
    padding-top: 20px;
    margin: 0 auto;
  }
  .sub-name{
    line-height: 30px;
  }
  .wrap-line{
    line-height: 25px;
  }
  .sign{
    width: 90%;
    height: 40vh;
    border-radius: 10px;
    background-color: #fff;
  }
  .sign-title{
    text-align:center;
    padding-bottom: 30px;
    font-size: 20px;
    overflow: hidden;
    text-overflow: ellipsis;
    width: 100%;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 3;
    word-break: break-all;
    
  }
  .sign-btn{
    width: 100%;
    margin-top: 30px;
    text-align: center;
  }
  .num-txt{
    margin-left: 15px;
    padding: 8px 15px;
    color:#fff;
    border: none;
    background-color: rgb(242, 31, 45);
  }
  .number{
    padding:10px;
    border: none;
    margin-right: 2px;
    color:#fff;
    cursor: pointer;
    background-color: forestgreen;
  }

  .card-number{    
    width: 40px;
    height: 40px;
    line-height: 40px;
    border-radius: 50%;
    color:#fff;
    font-size: 18px;
    text-align: center;
    margin-right: 8px;
    background-color: #3bcdf1;
    box-shadow:  2px 2px 10px rgba(61, 38, 38, 0.4);
  }
  .card-number-q{
    padding: 8px;
    font-size: 16px;
    color:#fff;
    text-align: center;
    margin-left: 15px ;
    border-radius: 50%;
    background-color: red;
  }
  .overflow-ellipsis-2{
    overflow: hidden;
    text-overflow: ellipsis;
    width: 100%;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    word-break: break-all;
  }
  .card-pok{
    display: flex;
    flex-wrap: wrap;
  }
  .mg-tb-10{
    margin: 10px 0;
  }
  .back-pre-page{
    display: flex;
    align-items: center;
  }
  .ramain-txt{
    font-size: 20px;
    color: red;
    margin-left: 20px;
  }
.direction{
    display: flex;
    align-items: center;
    margin: 10px 0;
    color:#000;
    font-weight: bold;
}

.table-score {  
    display: flex;  
    flex-direction: column;  
    border: 1px solid #ccc;  
    overflow: scroll;
    margin: 15px 0 0px 0;    
}      
.table-tr {  
    display: flex;  
}  
.table-td {  
    flex: 1; /* 让单元格宽度平分 */  
    text-align: center; /* 文本居中 */  
    border-right: 1px solid #ccc;
    border-bottom: 1px solid #ccc; /* 单元格之间分隔线 */  
    padding: 5px 8px;
    min-width: 15px;
}
 .tip-bottom{
    text-align: center;
    padding: 10px 0 30px 0;
}
::-webkit-scrollbar {
  width: 4px;
  height: 4px;
}

::-webkit-scrollbar-track {
  background-color: #FFFFFF;
  border-radius: 10px;
}

::-webkit-scrollbar-thumb {
  background-color: #39b54a;
  border-radius: 10px;
}
}
.games-num{
    font-size: 12px;
    margin:2px 2px 8px 2px;
}
.isSelected{
    background-color: #faca09;   
}
.isLastGames{
    // #eb7b29
    background-color: #f75e00
}
.score-round{
    background-color: #f06414;
    border: none;
}
.filter-item{
  padding: 4px 8px;
  border: 1px solid #e1e1e1;
  border-radius: 16px;
  margin-right: 10px;
}
.isChecked{
  color: red;
  padding: 4px 8px;
  border: 1px solid rgb(233, 52, 52);
  border-radius: 16px;
  margin-right: 10px;
  background-color: #fad5d5;
}
</style>
<style lang='scss'>
.my-messageBox .el-message-box__message{
    font-size: 20px !important;
}
.custom-cancel-button {
    margin-left: 20px;
}
.my-messageBox  .el-message-box__btns{
    display: flex;
    font-size: 20px !important;
    flex-direction: row-reverse;
    justify-content: center;
}
.my-messageBox .el-button--small{
    font-size: 20px !important;
}

</style>


// WEBPACK FOOTER //
// src/views/signIn/signIn.vue